import { message, Space } from 'antd';
import axios from 'axios';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';
import ActionBar from '../../../../components/action-bar';
import ActionButton from '../../../../components/action-button';
import MiniTable from '../../../../components/mini-table';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import useLoading from '../../../../hooks/useLoading';
import unwrapAxiosPromise from '../../../../util/unwrapAxiosPromise';
import { openPopup } from '../../../../util/window';
import styles from '../_styles.less';
import { isDiretorSelector, isGestorSelector } from "../../../../store/autenticacao";
import { fetchTiposTrabalho, tiposTrabalhoSelector } from "../../../../store/consultivoArea";
import ConsultivoAreaTiposTrabalhoTable from "./_table";
import { fetchVerificarLimite } from '../../../../store/empresa';

export default function ConsultivoAreaTiposTrabalhoDetailPage() {
  const miniTableRef = useRef();
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const isEditable = useSelector(isDiretorSelector);
  const tiposTrabalho = useSelector(tiposTrabalhoSelector);
  const loading = useLoading(fetchTiposTrabalho.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const areaId = match.params.areaId;
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const handleCreate = () => {
    unwrapAxiosPromise(dispatch(fetchVerificarLimite()))
    .then(() => {
    history.replace(`/consultivo/areas/${areaId}/tipos-trabalho/create`);
    })
  };

  const handleRemove = () => {
    setLoadingRemove(true);
    unwrapAxiosPromise(axios.delete(`/consultivo/areas/${areaId}/tipos-trabalho`, { params: { ids: selectedIds } }))
      .then(() => {
        message.success(t('Registro(s) removido(s) com sucesso'));
        setSelectedIds([]);
        dispatch(fetchTiposTrabalho({ areaId }));
      })
      .finally(() => setLoadingRemove(false));
  };

  const handleDetail = tipoTrabalho => {
    history.replace(`/consultivo/areas/${areaId}/tipos-trabalho/${tipoTrabalho.id}`);
  };

  const handleLogs = () => {
    openPopup(`/logs?categoria=/consultivo/areas/${areaId}/tipos-trabalho/`, `logs_/consultivo/areas/${areaId}/tipos-trabalho/`);
  };

  const actions = [];
  if (isEditable) {
    actions.push(<ActionButton.Create onClick={handleCreate}/>);
    actions.push(<ActionButton.Remove
      disabled={selectedIds.length === 0}
      onClick={handleRemove}
      loading={loadingRemove}
    />);
  }
  actions.push(<ActionButton.Logs noTitle onClick={handleLogs}/>);
  actions.push(<MiniTable.DownloadButton disabled={loading || tiposTrabalho.length === 0} miniTableRef={miniTableRef}/>);
  const title = () => <ActionBar>{actions}</ActionBar>;
  return (
    <Space direction="vertical" className={styles['space']}>
      <ConsultivoAreaTiposTrabalhoTable
        dataSource={tiposTrabalho}
        loading={loading}
        miniTableRef={miniTableRef}
        onClick={handleDetail}
        onSelectedIdsChange={setSelectedIds}
        selectedIds={selectedIds}
        title={title}
      />
    </Space>);
}
